<template>
  <div class="page2">
    <h3>결제내역 조회</h3>

    <!-- 상단 50% : 결제 내역 목록 (스펙107: 큰 글씨 하단 작은 글씨 "결제 내역 목록") -->
    <div class="half">
      <div class="half-title">결제 내역 목록</div>
      <PaymentHistory ref="top" :hide-title="true" />
    </div>

    <!-- 하단 50% : 주문 불러오기 완료 임시 목록 (스펙234_개선_14: staff/admin 표시) -->
    <div class="half" v-if="canView">
      <div class="half-title">주문 불러오기 완료 임시 목록</div>
      <ManualPurchase :hide-title="true" @applied="onApplied" />
    </div>
  </div>
</template>

<script>
import PaymentHistory from './PaymentHistory.vue';
import ManualPurchase from './ManualPurchase.vue';
import { getAuth } from '../store/auth';

export default {
  name: 'PaymentInquiry2',
  components: { PaymentHistory, ManualPurchase },
  computed: {
    // 스펙234_개선_14: 주문 불러오기 완료 임시 목록은 staff/admin 표시
    canView() { const r = getAuth().role; return r === 'admin' || r === 'staff'; }
  },
  methods: {
    // 수동 저장분을 결제내역에 적용하면 상단(결제내역 조회)도 재조회
    onApplied() { if (this.$refs.top && this.$refs.top.reload) this.$refs.top.reload(); }
  }
};
</script>

<style scoped>
.page2 { padding: 4px; }
.page2 > h3 { margin: 4px 0 10px; }
.half { border: 1px solid #e4e9f2; border-radius: 8px; padding: 6px 10px; margin-bottom: 12px; max-height: 46vh; overflow: auto; }
.half-title { font-size: 13px; font-weight: 700; color: #33405c; margin: 4px 2px 6px; }
</style>
